var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-base-component',{attrs:{"subscribed_modules":_vm.subscribed_modules},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v(" "+_vm._s(_vm.my_report)+" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }